import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vw-checkbox",
  templateUrl: "./checkbox.component.html",
  imports: [ReactiveFormsModule],
})
export class CheckboxComponent {
  readonly id = input<string>();
  readonly label = input<string>();
  readonly parentForm = input.required<FormGroup>();
  readonly formControlProp = input<string | number>();

  constructor() {}
}
